export default function constant(value = '', options = {}) {
  const values = Array.isArray(options.value) ? options.value : [options.value];

  if ((options.extra || []).concat(value).some((i) => values.includes(i))) {
    return false;
  }

  return true;
}

constant.message = function message(value, options = {}) {
  const values = Array.isArray(options.value) ? options.value : [options.value];
  let label;

  if (['true', 'false'].includes(String(options.value))) {
    label = [true, 'true'].includes(options.value) ? '"sim"' : '"não"';
  } else if (!['', undefined, null].includes(options.value)) {
    label = `"${values.join('" ou "')}"`;
  }

  return options.message || (label ? `precisa ser igual a ${label}` : 'é diferente do esperado');
};
